import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";

import type { DetailedLinkedInEvent } from "../types";

async function getLinkedInEventRequest(
  workspaceId: string,
  accountId: string,
  eventId: string,
): Promise<DetailedLinkedInEvent> {
  return (
    await get(
      `workspaces/${workspaceId}/accounts/${accountId}/events/${eventId}`,
    )
  ).event;
}

export default function useLinkedInEventDetails(
  accountId: string,
  eventId: string,
) {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { leadListSourcesKeys } = getQueryKeys(workspaceId);

  const { data: linkedInEvent, isLoading: isLoadingLinkedInEvent } = useQuery({
    queryKey: leadListSourcesKeys.linkedInEvent(accountId, eventId),
    queryFn: () => getLinkedInEventRequest(workspaceId, accountId, eventId),
  });

  return {
    linkedInEvent,
    isLoadingLinkedInEvent,
  };
}
